module.exports = __webpack_public_path__ + "img/DNADamage-OVCA_GSE227019.d9c1eaa8.png";